<div class="menu-indice"><a routerLink="../../../gestionconstancia/{{a_tipo}}">{{titulo}}</a> / {{nombre_constancia}}</div>
<mdb-card>
    <mdb-card-body>
        <div class="form-row align-items-center">
            <div class="form-group col-md-3">
                <div class="md-form mt-0 mb-0">
                    <input type="text" id="txt_nombre" maxlength="100" [(ngModel)]="txt_nombre" class="form-control" mdbInput>
                    <label for="txt_nombres">Nombre</label>
                </div>
            </div>
            <div class="form-group col-md-1">
              Estado:
          </div>
          <div class="form-group col-md-3">
                    <select class="browser-default custom-select" [(ngModel)]="cboEstado" (change)="onChangeEstado()">
                    <option value="0" selected>Todos</option>
                    <option *ngFor="let listEstado of listEstado" [value]="listEstado.c_tabla">{{listEstado.x_valor}}</option>
                    </select>
          </div>
          <div class="form-group col-md-1">
            Correo:
          </div>
          <div class="form-group col-md-2">
            <select class="browser-default custom-select" [(ngModel)]="cboCorreo" (change)="onChangeCorreo()">
              <option value="-1" selected>Todos</option>
              <option value="0" selected>Sin enviar</option>
              <option value="1" selected>Enviado</option>
            </select>
           </div>
            <div class="form-group col-md-2">
              <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar()"  size="md" color="blue" mdbWavesEffect>
              <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
            </div>
        </div>
    </mdb-card-body>
  </mdb-card>
  <br/>
  <mdb-card>
     <div class="form-row d-flex justify-content-center" style="padding-top: 10px;">
        <div class="form-group col-md-2">
        <button mdbBtn type="button" id="btnNuevo"  size="md" color="teal" mdbWavesEffect  [matMenuTriggerFor]="menu">
        <mdb-icon fas icon="user-plus" class="mr-2"></mdb-icon>Nuevo {{tipo_participante}}(a)</button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onNuevoParticipante()" style="background-color:aliceblue">
            <mdb-icon fas icon="user" class="mr-2"></mdb-icon>Individual</button>
          <button mat-menu-item (click)="onNuevosParticipanteCsv()" style="background-color: aliceblue">
            <mdb-icon fas icon="users" class="mr-2"></mdb-icon>Grupal (CSV)</button>
        </mat-menu>
      </div>
        <div class="form-group col-md-2" *ngIf="false">
          <button mdbBtn type="button" id="btnNuevo" size="md"  color="blue" mdbWavesEffect>
          <mdb-icon fas icon="file" class="mr-2"></mdb-icon> Plantilla {{tipo_participante}}</button>
        </div>
        <div class="form-group col-md-2"  *ngIf="maeConstanciaE.c_curso == 0">
          <button mdbBtn type="button" id="btnEliminarTodos" (click)="onEliminarTodos()" size="md" color="blue" mdbWavesEffect>
          <mdb-icon fas icon="minus-circle" class="mr-2"></mdb-icon>Eliminar Todos</button>
        </div>
        <div class="form-group col-md-2"  *ngIf="maeConstanciaE.c_curso != 0">
          <button mdbBtn type="button" id="btnAV" (click)="onAgregarAV()" size="md" color="blue" mdbWavesEffect>
          <mdb-icon fas icon="users" class="mr-2"></mdb-icon>{{tipo_participante}} de Aula Virtual</button>
        </div>
        <div class="form-group col-md-2">
          <button mdbBtn type="button" id="btnGenerar" (click)="onGenerarTodos()"  size="md" color="blue" mdbWavesEffect>
          <mdb-icon fas icon="copy" class="mr-2"></mdb-icon>Generar todos</button>
        </div>
        <div class="form-group col-md-2">
          <button mdbBtn type="button" id="btnEnviarFirma"  (click)="onEnviarFirmaTodos()"  size="md" color="blue" mdbWavesEffect>
          <mdb-icon fas icon="share-square" class="mr-1"></mdb-icon>Enviar a firma todos</button>
        </div>
        <div class="form-group col-md-2">
          <button mdbBtn type="button" id="btnEnviarCorreo"  (click)="onEnviarCorreoTodos()" size="md" color="blue" mdbWavesEffect>
          <mdb-icon fas icon="paper-plane" class="mr-1"></mdb-icon>Enviar Correo todos</button>
        </div>
  </div>
  </mdb-card>
  <br/>
  <mdb-card>
    <div class="table-responsive">
    <table mdbTable hover="true" class="table">
        <thead>
          <tr>
            <th *ngFor="let head of headElements" scope="col">{{head}}</th>
          </tr>
        </thead>
        <tbody>
          <tr mdbTableCol *ngFor="let listParti of listParticipantes | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
            <th>{{i + 1+ (page-1)*10}}</th>
            <th>{{listParti.x_nombres}}</th>
            <!--<td>{{listParti.x_correo}}</td>
            <td>{{listParti.x_nota}}</td>-->
            <td>{{listParti.x_estado}}</td>
            <td><button  (click)="onEditar(listParti)" type="button" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="edit" size="lg"></mdb-icon></button></td>
            <td>
            <button *ngIf="listParti.x_uid_doc != 0 && listParti.c_estado < 23"  (click)="onDescargarArchivo(listParti.c_participante,listParti.x_uid_doc,'.docx')" type="button" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="file-word" size="lg"></mdb-icon></button>
            <button *ngIf="listParti.x_uid_pdf != 0 && listParti.c_estado == 24" (click)="onVisualizarDocumento(listParti,0)" type="button" color="orange" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="file-pdf" size="lg"></mdb-icon></button>
            <button *ngIf="listParti.x_uid_pdf != 0 && (listParti.c_estado > 24 || listParti.c_estado == 23)" [color]="listParti.c_estado == 25 ? 'lime':listParti.c_estado == 26?'green':'red'"
              routerLink="../../../firmado/r/{{listParti.c_participante}}" type="button" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="file-pdf" size="lg"></mdb-icon></button>
            </td>
            <td>
              <button *ngIf="(listParti.c_estado < 24)||(id_usuario=='1')" [color]="listParti.c_estado==21?'blue':'light-blue'" (click)="onGenerar(listParti)" type="button" color="light-blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="copy" size="lg"></mdb-icon></button>
            </td>
            <td><button *ngIf="listParti.x_uid_doc != 0 && listParti.c_estado == 22"  (click)="onEnviarFirma(listParti)" type="button" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="share-square" size="lg"></mdb-icon></button></td>
            <td>
              <button *ngIf="listParti.x_uid_pdf != 0 && listParti.c_estado == 26" [color]="listParti.l_envio_correo=='1'?'light-green':'blue'"  (click)="onEnviarCorreo(listParti)" type="button" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="paper-plane" size="lg"></mdb-icon></button>
            </td>

          </tr>
        </tbody>
      </table>

      </div>
        <div class="text-center">

          <ngb-pagination [maxSize]=4 [(page)]="page" class="d-flex justify-content-center"
            [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listParticipantes.length">
          </ngb-pagination>

        </div>
  </mdb-card>

  <br>
